<template>
  <div>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">LIST OF REQUEST CREDITED</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap class="align-center mx-2 mt-5">
        <v-layout col>
          <v-flex xs12 md3>
            <v-select
              v-model="month_of_id"
              class="mx-2"
              :items="month_of_items"
              item-value="id"
              item-text="month_of"
              label="Month Of"
              required
              :rules="rules.combobox_rule"
              dense
              @change="selected_month"
              outlined
            ></v-select>
            <v-data-table
              dense
              :headers="headers2"
              :items="vouchered_items"
              height="600"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item="{ item }">
                <tr @click="activerow(item)"
                    :class="{ 'info white--text': item.id === selectedDepositId }">
                  <td>
                    {{ item.voucher_no }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 md9 class="mx-2" v-if="data_items.length > 0">
            <v-card>
              <h3>
                Print |
                <v-icon class="mr-2" color="success" @click="print_data"
                        v-if="!printt && (!no_cheque_uploaded||auto_deb)">
                  {{ icons.mdiPrinter }}
                </v-icon>
                <v-progress-circular :size="25" :width="5" color="success" indeterminate
                                     v-if="printt"></v-progress-circular>
              </h3>
              <h2>Request Data | Total: P {{ total_amount }}</h2>
              <v-data-table
                dense
                :headers="headers"
                :items="data_items"
                height="600"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>
                      {{ item.id }}
                    </td>
                    <td>
                      {{ item.request_id }}
                    </td>
                    <td>
                      {{ item.category.category }}
                    </td>
                    <td>
                      {{ item.branch != null ? item.branch.branch_code : '' }}
                    </td>
                    <td>
                      {{ item.particulars.particulars }}
                    </td>
                    <td>
                      {{ item.description }}
                    </td>
                    <td>
                      {{ item.credit_to }}
                    </td>
                    <td>
                      {{ item.payment_for }}
                    </td>
                    <td>
                      {{ formatPrice(item.amount) }}
                    </td>
                    <td class="text-center">
                      <div v-if="item.is_credited===1">
                        {{ 'CREDITED' }}
                      </div>
                      <div v-if="item.is_credited===0">
                        {{ 'ON PROCESS' }}
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-card>
    <snack-bar-dialog :snackbar_flag="this.snackbar" :color="this.snackbar_color"
                      :snackbar_text="this.snackbar_text"/>
  </div>
</template>

<script>
import {
  mdiAccountOutline, mdiAccountCashOutline, mdiInformationOutline, mdiPrinter
  , mdiCloudUpload
  , mdiMonitorEye
  , mdiCheckDecagram
} from '@mdi/js'
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex'
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'
import ViewUploadCheque from '@/views/report_interface/vouchers/components/ViewUploadCheque'

const initialState = () => {
  return {
    key: 0,
    show: false,
    avatarImg: require('@/assets/images/misc/upload_cheque.jpg'),

    croppieImage: '',
    cropped: require('@/assets/images/misc/upload_cheque.jpg'),

    saving_data: false,
    printt: false,
    upload: false,
    can_upload: false,
    auto_deb: false,

    alert: false,
    alert_message: '',
    saving_data_request: false,
    alert_request: false,
    alert_message_request: '',
    total_amount: 0,
    headers: [
      {text: 'ID', value: 'date_of_deposit', sortable: false},
      {text: 'Request ID', value: 'tin', sortable: false},
      {text: 'Category', value: 'last_name', sortable: false},
      {text: 'Branch', value: 'last_name', sortable: false},
      {text: 'Particulars', value: 'last_name', sortable: false},
      {text: 'Description', value: 'last_name', sortable: false},
      {text: 'Credit To', value: 'last_name', sortable: false},
      {text: 'Payment For', value: 'last_name', sortable: false},
      {text: 'Amount', value: 'last_name', sortable: false},
      {text: 'Status', value: 'last_name', sortable: false},
    ],
    headers2: [
      {text: 'Voucher#', value: 'date_of_deposit', sortable: false},
    ],
    data_items_originaldata_items_original: [],
    data_items: [],
    uploaded_data_items: [],
    data_items2: [],
    request_id: '',
    request_items: [],
    category_id: '',
    category_items: [],
    month_of_id: '',
    month_of_items: [],
    allocation_of_fund: '',
    payee: '',
    is_auto_debit: false,
    cheque_no: '',
    cheque_date: '',
    voucher_no: '',
    bank_id: '',
    bank_items: [],
    cheque_items: [],
    vouchered_items: [],
    selectedDepositId: -1,
    has_existing_voucher: false,
    existing_voucher: {},

    can_view_uploaded_cheque: false,
    is_deleting: false,

    no_cheque_uploaded: false,
  }
}
export default {
  components: {
    snackBarDialog,
    ViewUploadCheque,
  },
  setup() {
    return {
      icons: {
        mdiAccountOutline,
        mdiAccountCashOutline,
        mdiInformationOutline,
        mdiPrinter,
        mdiCloudUpload,
        mdiMonitorEye,
        mdiCheckDecagram,
      },
    }
  },
  data() {
    return initialState()
  },
  mounted() {
    this.initialize_data()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('authentication', [
      'employee_id',
      'month_of',
      'address',
      'contact',
      'name',
      'department',
      'position',
      'employee_branch_id',
      'name_credit',
    ]),
    ...mapGetters('system_data', [
      'snackbar',
      'snackbar_color',
      'snackbar_text',
      'company_logo',
      'damayan',
      'chapel',
      'factory',
      'coop',
      'printing',
      'accounting',
      'admin',
      'amd',
      'audit',
      'book',
      'creative',
      'ecut',
      'hr',
      'it',
      'prot',
      'trea',
    ]),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('cash_vouchers', ['list_of_cash_voucher_credited_employee']),
    ...mapActions('cheque_vouchers', ['list_of_cheque_voucher_credited_employee']),
    ...mapActions('category', ['list_of_available_for_cash_voucher']),
    ...mapActions('transaction_months', ['list_of_transaction_month']),
    ...mapActions('uploaded_cheque', ['get_uploaded_cheque', 'upload_cheque']),

    croppie(e) {
      this.show = true
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      var reader = new FileReader()
      reader.onload = e => {
        this.cropped = this.croppieImage = e.target.result
      }
      reader.readAsDataURL(files[0])
    },
    resett() {
      this.$refs.refInputEl.value = ''
      this.cropped = this.avatarImg
      this.croppieImage = ''
      this.alert = false
    },
    upload_data() {
      var proceed = true
      if (this.croppieImage === '') {
        this.alert = true
        this.alert_message = 'Please Upload Photo'
        this.saving = false
        proceed = false
      }
      if (proceed) {
        const data = new FormData()
        data.append(
          'month_of',
          this.month_of_items[
            this.month_of_items
              .map(function (x) {
                return x.id
              })
              .indexOf(this.month_of_id)
            ].month_of,
        )
        data.append('cv_id', this.existing_voucher.id)
        data.append('ckv_id', '')
        data.append('ftv_id', '')
        data.append('scan_cheque_location', this.croppieImage)
        this.upload_cheque(data)
          .then(response => {
            this.change_snackbar({
              show: true,
              color: response.status === 200 ? 'success' : 'error',
              text: response.data,
            })
            if (response.status === 200) {
              this.resett()
            }
          })
          .catch(error => {
            this.alert = true
            this.alert_message = error
            this.saving = false
          })
      }
    },
    initialize_data() {
      this.list_of_transaction_month()
        .then(response => {
          this.month_of_items = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    async selected_month(value) {
      this.data_items = []
      this.data_items2 = []
      let data = []
      this.total_amount = '0'
      this.selectedDepositId = -1
      await this.list_of_cash_voucher_credited_employee({
        month_of_id: value,
        name: this.name_credit,
      })
        .then(response => {
          response.data.forEach(function (item) {
            data.push(item)
          });

        })
        .catch(error => {
          console.log(error)
        })
      await this.list_of_cheque_voucher_credited_employee({
        month_of_id: value,
        name: this.name_credit,
      })
        .then(response => {
          response.data.forEach(function (item) {
            data.push(item)
          });
        })
        .catch(error => {
          console.log(error)
        })
      this.vouchered_items = data
    },
    date_format(value) {
      return moment(value)
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    async activerow(value) {
      this.data_items = value.request_data
      this.data_items2 = value.uploaded_cheque
      this.selectedDepositId = value.id
      if (value.is_customize) {
        let arr = []
        value.request_data.forEach(function (item) {
          if (item.cheque_no === 0) {
            arr.push(item)
          }
        })
        this.data_items = arr
      }
      var tto = 0
      this.data_items.forEach(function (item) {
        tto += parseFloat(item.amount)
      })
      this.total_amount = this.formatPrice(tto)
      this.existing_voucher = value
      this.auto_deb = value.cheque_no === 0
    },
    async print_data() {
      this.printt = true
      var imgData = this.company_logo

      var payments_array = []
      var widths = []

      var info_array = []
      var cheque_array = {}
      var voc_no = 'CV#' + this.existing_voucher.voucher_no

      var damayan_ = this.damayan
      var chapel_ = this.chapel
      var factory_ = this.factory
      var coop_ = this.coop
      var printing_ = this.printing

      widths = [20, 40, 40, 60, 110, 70, 70, 55, 20]
      payments_array.push([
        {text: 'Req. ID', alignment: 'left', style: 'main_info'},
        {text: 'Category', alignment: 'left', style: 'main_info'},
        {text: 'Branch', alignment: 'left', style: 'main_info'},
        {text: 'Particulars', alignment: 'left', style: 'main_info'},
        {text: 'Description', alignment: 'left', style: 'main_info'},
        {text: 'Credit To', alignment: 'left', style: 'main_info'},
        {text: 'Payment For', alignment: 'left', style: 'main_info'},
        {text: 'Amount', alignment: 'left', style: 'main_info'},
        {text: 'Status', alignment: 'left', style: 'main_info'},
      ])
      var tott = this.total_amount
      this.data_items.forEach(function (item, index, payment) {
        payments_array.push([
          {
            text: item.request_id,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.category.category,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.branch != null ? item.branch.branch_code : '',
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.particulars.particulars,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.description,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.credit_to,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.payment_for,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text:
              item.amount === 0
                ? ''
                : (item.amount / 1)
                  .toFixed(2)
                  .replace(',', '.')
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.is_credited === 1 ? 'CREDITED' : 'ON PROGRESS',
            alignment: 'left',
            style: 'tableExample2',
          },
        ])
        if (Object.is(payment.length - 1, index)) {
          // execute last item logic
          payments_array.push([
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: 'TOTAL',
              alignment: 'right',
              style: 'tableExample2',
            },
            {
              text: tott,
              alignment: 'left',
              style: 'tableExample2',
            },
            {
              text: '',
            },
          ])
        }
      })

      info_array = [
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'MONTH OF: ',
                {
                  text: this.month_of_items[
                    this.month_of_items
                      .map(function (x) {
                        return x.id
                      })
                      .indexOf(this.month_of_id)
                    ].month_of,
                  style: 'main_data',
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'VOUCHER #: ',
                {
                  text: voc_no,
                  fontSize: 15,
                  bold: true,
                },
              ],
            },
          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'VOUCHER DATE: ',
                {
                  text: this.existing_voucher.cheque_date,
                  style: 'main_data',
                },
              ],
            },
          ],
        },

      ]

      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs
      }
      var docDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        content: [
          {
            columns: [
              {image: imgData, width: 60, height: 54, style: 'logo'},
              {
                stack: [
                  'GOODLIFE GROUP OF COMPANIES',
                  {text: this.address, style: 'subheader2'},
                  {
                    text: this.contact,
                    style: 'subheader2',
                  },
                  {
                    text: 'Printed as of: ' + moment().format('MMMM D, YYYY'),
                    style: 'printed_label',
                  },
                ],
                style: 'header',
              },
              {
                image: this.trea,
                width: 60,
                height: 54,
                style: 'logo',
              },
            ],
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: 'LIST OF CREDITED',
                    style: {
                      fontSize: 16,
                      alignment: 'center',
                      bold: true,
                    },
                  },
                ],
              },
            ],
          },
          '__________________________________________________________________________________________________',
          {
            columns: [{text: ' '}],
          },
          {
            columns: [{text: ' '}],
          },
          {
            stack: info_array,
          },
          {
            columns: [{text: ' '}],
          },
          {
            table: {
              widths: widths,
              body: payments_array,
              style: {fontSize: 1},
            },
            layout: {
              fillColor: function (rowIndex) {
                return rowIndex === 0 ? '#CCCCCC' : null
              },
            },
          },
        ],
        footer: function (currentPage, pageCount) {
          return {
            margin: 10,
            columns: [
              {
                text: 'Page ' + currentPage.toString() + ' of ' + pageCount,
                fontSize: 9,
                alignment: 'left',
              },
              {image: damayan_, width: 34, height: 20, style: 'logo'},
              {image: chapel_, width: 34, height: 20, style: 'logo'},
              {image: factory_, width: 34, height: 20, style: 'logo'},
              {image: coop_, width: 34, height: 20, style: 'logo'},
              {image: printing_, width: 34, height: 20, style: 'logo'},
              {
                columns: [
                  {
                    text: 'VOUCHER #:',
                    fontSize: 9,
                    bold: true,
                    alignment: 'right',
                  },
                  {
                    text: voc_no,
                    fontSize: 10,
                    bold: true,
                    alignment: 'left',
                  },
                ],
              },
            ],
          }
        },
        styles: {
          tableExample: {
            fontSize: 9,
          },
          tableExample2: {
            fontSize: 7,
          },
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 5], //[left, top, right, bottom]
          },
          subheader: {
            fontSize: 11,
          },
          subheader2: {
            fontSize: 10,
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          main_data: {
            margin: [0, 2, 0, 2],
            fontSize: 9,
            bold: true,
            alignment: 'left',
          },
          main_data_2: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
            bold: true,
            alignment: 'left',
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
            alignment: 'left',
          },
        },
      }
      pdfMake.createPdf(docDefinition).open()
      this.printt = false
    },
    async print_crs() {
      this.printt = true
      var imgData = this.company_logo

      var payments_array = []
      var widths = [40, 60, 60, 220, 90, 40]
      var addr = this.address
      var cont = this.contact
      var pos = this.position

      var ad = this.admin
      var tree = this.trea
      var accc = this.accounting
      var ammdd = this.amd
      var proo = this.prot
      var hrrr = this.hr
      var boook = this.book
      var voc_no = 'CV#' + this.existing_voucher.voucher_no

      this.data_items.forEach(function (item, index, payment) {
        var array_data = []
        array_data.push([
          {text: 'Category', alignment: 'left', style: 'main_info'},
          {text: 'Branch', alignment: 'left', style: 'main_info'},
          {text: 'Particulars', alignment: 'left', style: 'main_info'},
          {text: 'Description', alignment: 'left', style: 'main_info'},
          {text: 'Payment For', alignment: 'left', style: 'main_info'},
          {text: 'Amount', alignment: 'left', style: 'main_info'},
        ])
        array_data.push([
          {
            text: item.category.category,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.branch != null ? item.branch.branch_code : '',
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.particulars.particulars,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.description,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text: item.payment_for,
            alignment: 'left',
            style: 'tableExample2',
          },
          {
            text:
              item.amount === 0
                ? ''
                : (item.amount / 1)
                  .toFixed(2)
                  .replace(',', '.')
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2',
          },
        ])
        payments_array.push([
          {
            columns: [
              {image: imgData, width: 40, height: 34, style: 'logo'},
              {
                stack: [
                  'GOODLIFE GROUP OF COMPANIES',
                  {text: addr, style: 'subheader2'},
                  {
                    text: cont,
                    style: 'subheader2',
                  },
                  {
                    text: 'Printed as of: ' + moment().format('MMMM D, YYYY'),
                    style: 'printed_label',
                  },
                ],
                style: 'header',
              },
              {
                image:
                  pos === 'ADMIN'
                    ? ad
                    : pos === 'TREASURY'
                      ? tree
                      : pos === 'ACCOUNTING'
                        ? accc
                        : pos === 'AMD'
                          ? ammdd
                          : pos === 'PROPERTY CUSTODIAN'
                            ? proo
                            : pos === 'HUMAN RESOURCE'
                              ? hrrr
                              : pos === 'BOOKKEEPING'
                                ? boook
                                : pos === 'CMD'
                                  ? accc
                                  : imgData,
                width: 40,
                height: 34,
                style: 'logo',
              },
            ],
          },
          {
            text: 'CASH RELEASED SLIP of ' + voc_no,
            style: {
              fontSize: 11,
              alignment: 'center',
              bold: true,
            },
          },
          {
            table: {
              widths: widths,
              body: array_data,
              style: {fontSize: 1},
            },
            layout: {
              fillColor: function (rowIndex) {
                return rowIndex === 0 ? '#CCCCCC' : null
              },
            },
          },
          {text: ' '},
          {text: ' '},
          {text: item.credit_to, alignment: 'center', style: 'subheader3'},
          {text: 'SIGNATURE OVER PRINTED NAME', alignment: 'center', style: 'subheader2'},
        ])
        if ((index + 1) % 4 === 0) {
          payments_array.push([{text: ' '}, {text: ' '}, {text: ' '}, {text: ' '}, {text: ' '}])
        }
      })

      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs
      }
      var docDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        content: payments_array,
        styles: {
          tableExample: {
            fontSize: 9,
          },
          tableExample2: {
            fontSize: 7,
          },
          header: {
            fontSize: 15,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 5], //[left, top, right, bottom]
          },
          subheader3: {
            fontSize: 11,
          },
          subheader: {
            fontSize: 9,
          },
          subheader2: {
            fontSize: 8,
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          main_data: {
            margin: [0, 2, 0, 2],
            fontSize: 9,
            bold: true,
            alignment: 'left',
          },
          main_data_2: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
            bold: true,
            alignment: 'left',
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
            alignment: 'left',
          },
        },
      }
      pdfMake.createPdf(docDefinition).open()
      this.printt = false
    },
  },
}
</script>
